export default [
    {
        path: '/album',
        name: 'album',
        meta: {
            name: '商品专辑',
            keepAlive: true
        },
        component: () => import('@/views/commodity-center/album/list/index.vue')
    },
    {
        path: '/album-add',
        name: 'album-add',
        meta: {
            backName: 'album',
            name: '新增商品专辑',
            parentsName: 'album',
            keepAlive: true
        },
        component: () => import('@/views/commodity-center/album/addOrEdit/index.vue')
    },
    {
        path: '/album-edit/:id',
        name: 'album-edit',
        meta: {
            backName: 'album',
            name: '编辑商品专辑',
            parentsName: 'album',
            keepAlive: true
        },
        component: () => import('@/views/commodity-center/album/addOrEdit/index.vue')
    },
    {
        path: '/album-copy/:id',
        name: 'album-copy',
        meta: {
            backName: 'album',
            name: '复制商品专辑',
            parentsName: 'album',
            keepAlive: true
        },
        component: () => import('@/views/commodity-center/album/addOrEdit/index.vue')
    },
]
